// src/components/MedalsPage/DragonCelebration.jsx
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import './DragonCelebration.css';

export default function DragonCelebration({ dragon, onClose }) {
  const [imageOk, setImageOk] = useState(true);
  const [closing, setClosing] = useState(false);
  const closedRef = useRef(false);
  const autoTimerRef = useRef(null);
  const closeTimerRef = useRef(null);

  const handleClose = () => {
    if (closedRef.current) return;
    closedRef.current = true;
    setClosing(true);
    closeTimerRef.current = setTimeout(() => onClose(), 500);
  };

  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    autoTimerRef.current = setTimeout(handleClose, 8000);
    const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
    document.addEventListener('keydown', onKey);

    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
      clearTimeout(autoTimerRef.current);
      clearTimeout(closeTimerRef.current);
      document.removeEventListener('keydown', onKey);
    };
    
  }, []);

  const particles = useMemo(() => {
    const arr = [];
    const count = 34;
    for (let i = 0; i < count; i++) {
      const baseAngle = (i / count) * Math.PI * 2;
      const angle = baseAngle + (Math.random() * 0.35 - 0.175);
      const dist = 170 + Math.random() * 220;
      const x = Math.cos(angle) * dist;
      const y = Math.sin(angle) * dist;
      arr.push({
        id: i,
        x: `${x.toFixed(1)}px`,
        y: `${y.toFixed(1)}px`,
        size: `${(2.5 + Math.random() * 4).toFixed(1)}px`,
        delay: `${(1500 + Math.random() * 500).toFixed(0)}ms`,
        duration: `${(950 + Math.random() * 700).toFixed(0)}ms`,
        color: Math.random() > 0.55 ? dragon.c1 : dragon.c2,
      });
    }
    return arr;
  }, [dragon.c1, dragon.c2]);

  const content = (
    <div
      className={`dragon-celebration ${closing ? 'is-closing' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="celebration-title"
    >
      <div className="celebration-backdrop" onClick={handleClose} />

      <div className="celebration-flash" aria-hidden="true" />

      <div
        className="celebration-rays"
        style={{ '--c1': dragon.c1, '--c2': dragon.c2 }}
        aria-hidden="true"
      />

      <div
        className="celebration-shockwave shockwave-1"
        style={{ '--c1': dragon.c1 }}
        aria-hidden="true"
      />
      <div
        className="celebration-shockwave shockwave-2"
        style={{ '--c1': dragon.c1 }}
        aria-hidden="true"
      />

      <div className="celebration-particles" aria-hidden="true">
        {particles.map((p) => (
          <span
            key={p.id}
            className="celebration-particle"
            style={{
              '--x': p.x,
              '--y': p.y,
              '--size': p.size,
              '--delay': p.delay,
              '--duration': p.duration,
              '--color': p.color,
            }}
          />
        ))}
      </div>

      <div className="celebration-stage">
        <div
          className="celebration-aura"
          style={{ '--c1': dragon.c1, '--c2': dragon.c2 }}
          aria-hidden="true"
        />

        <div className="celebration-dragon-wrap">
          {dragon.image && imageOk ? (
            <img
              src={dragon.image}
              alt={dragon.name}
              className="celebration-dragon-img"
              onError={() => setImageOk(false)}
              draggable={false}
            />
          ) : (
            <span className="celebration-dragon-emoji">{dragon.emoji}</span>
          )}
          <div className="celebration-crown" aria-hidden="true"></div>
        </div>

        <div className="celebration-text">
          <div className="celebration-label" style={{ color: dragon.c1 }}>
            اژدهای جدید باز شد
          </div>
          <h1
            id="celebration-title"
            className="celebration-name"
            style={{ '--c1': dragon.c1, '--c2': dragon.c2 }}
          >
            {dragon.name}
          </h1>
          <div className="celebration-sub">
            به {dragon.minScore.toLocaleString()} امتیاز رسیدی
          </div>
        </div>

        <button className="celebration-btn" onClick={handleClose}>
          ادامه ماجراجویی
        </button>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}